import {
  Crown, Building2, GraduationCap, LineChart, Users, ShieldCheck, BookOpen,
  TrendingUp, Send, Sparkles, Gift, Star, Award, Zap, Target, Globe2, Lock,
  MessageSquareQuote, Rocket, HeartHandshake, BarChart3, Wallet,
} from "lucide-react";

export const ICONS = {
  Crown, Building2, GraduationCap, LineChart, Users, ShieldCheck, BookOpen,
  TrendingUp, Send, Sparkles, Gift, Star, Award, Zap, Target, Globe2, Lock,
  MessageSquareQuote, Rocket, HeartHandshake, BarChart3, Wallet,
};

export const ICON_NAMES = Object.keys(ICONS);

export function Icon({ name, className }) {
  const Cmp = ICONS[name] || Sparkles;
  return <Cmp className={className} />;
}
